import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function CreatingManagingTemplates() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Creating&nbsp;&amp;&nbsp;Managing Templates
      </Typography>

      <Typography paragraph>
        Turn any finished campaign into a <strong>Template</strong> so recurring
        jobs take seconds instead of minutes. A template stores the data source,
        channel and message, but lets you tweak scheduling and audience each run.
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;<strong>Templates list</strong> — shows&nbsp;Name, creation date,
            default data-source and the parent campaign.
          </Typography>
          <img
            src="../../static/docs/CreateTemplate.jpg"
            alt="Templates overview table"
            className="step-img"
          />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;<strong>Delete</strong> unwanted templates by ticking the checkbox
            and pressing&nbsp;<em>Delete</em>.
          </Typography>
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            3&nbsp;·&nbsp;<strong>Create template</strong> — name it, pick or upload a file/URL,
            select the delivery action, fill the message form, then hit&nbsp;<em>Save</em>.
          </Typography>
          <img
            src="../../static/docs/SelectActionTemplate.jpg"
            alt="Create new template wizard"
            className="step-img"
          />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            4&nbsp;·&nbsp;<strong>Template detail</strong> — switch between&nbsp;Overview,
            Edit and Preview tabs.
          </Typography>
           <Typography variant="h4">
            5&nbsp;·&nbsp;<strong>Run campaign</strong> — enter a fresh run name and click&nbsp;
            <em>Run&nbsp;Campaign</em>.
          </Typography>
          <img
            src="../../static/docs/templatedetails.jpg"
            alt="Create new template wizard"
            className="step-img"
          />
        </ListItem>


      </List>
    </Box>
  );
}